import "./profile_form.css";


const ProfileForm = ({setEmail,email, setFirstName, firstName,setLastName, lastName,setPassword, password, isErrors}) =>{

    const onChangeEmail= (e) =>{
        setEmail(e.target.value)
    }

    const onChangeFirstName= (e) =>{
        setFirstName(e.target.value)
    }

    const onChangeLastName= (e) =>{
        setLastName(e.target.value)
    }

    const onChangePassword= (e) =>{
        setPassword(e.target.value)
    }

    

    return(
      
            <form className="form-container">
                <label className="label-item">Email</label> <br/>
                <input onChange={onChangeEmail} className="input-item" placeholder="Enter your Email" value={email !== undefined && email.length>=1?email:""} type="email"></input> <br/>
                <label className="label-item">First Name</label> <br/>
                <input onChange={onChangeFirstName} className="input-item" placeholder="Enter your First Name" value={firstName !== undefined && firstName.length>=1?firstName:""} type="text"></input> <br/>
                <label className="label-item">Last Name</label> <br/>
                <input onChange={onChangeLastName} className="input-item" placeholder="Enter your Last Name" value={lastName !== undefined && lastName.length>=1?lastName:""} type="text"></input> <br/>
                <label className="label-item">Password</label><br/>
                <input onChange={onChangePassword} className="input-item" placeholder="Enter your Password" value={password !== undefined && password.length>=1?password:""} type="password"></input><br/>
                {isErrors[0]&&<div className="error-label">Error: Please Fill out all the fields.</div>}
                {isErrors[0] && password != undefined? password.length <= 8?<div className="error-label">Error: Password must be atleast 8 characters long.</div>:null:null}
            </form>

    )
}

export default ProfileForm;